module.exports = __webpack_public_path__ + "static/media/white-logo.24db8d00.svg";